(function () {
  'use strict';

  if (window.DirectResponseProduct20260812) {
    window.DirectResponseProduct20260812.init(document);
    return;
  }

  var ROOT_SELECTOR = '[data-dr-20260812-section]';
  var PURCHASE_SELECTOR = '[data-dr-20260812-purchase-root]';
  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function findAll(context, selector) {
    var nodes = [];
    if (context && context.matches && context.matches(selector)) nodes.push(context);
    if (context && context.querySelectorAll) {
      nodes = nodes.concat(Array.prototype.slice.call(context.querySelectorAll(selector)));
    }
    return nodes;
  }

  function money(cents, format) {
    var value = Number(cents || 0);
    var moneyFormat = format || '${{amount}}';

    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(value, moneyFormat);
    }

    function withDelimiters(number, precision, thousands, decimal) {
      var safeNumber = Number(number || 0);
      var fixed = (safeNumber / 100).toFixed(precision);
      var parts = fixed.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts.join(decimal);
    }

    var replacements = {
      amount: withDelimiters(value, 2, ',', '.'),
      amount_no_decimals: withDelimiters(value, 0, ',', '.'),
      amount_with_comma_separator: withDelimiters(value, 2, '.', ','),
      amount_no_decimals_with_comma_separator: withDelimiters(value, 0, '.', ','),
      amount_with_apostrophe_separator: withDelimiters(value, 2, "'", '.')
    };

    return moneyFormat.replace(/\{\{\s*(\w+)\s*\}\}/g, function (match, key) {
      return Object.prototype.hasOwnProperty.call(replacements, key) ? replacements[key] : match;
    });
  }

  function parseVariants(root) {
    var node = root.querySelector('[data-dr-20260812-variants-json]');
    if (!node) return [];
    try {
      var parsed = JSON.parse(node.textContent);
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      return [];
    }
  }

  function selectedVariant(root, variants) {
    var input = root.querySelector('[data-dr-20260812-variant-select]');
    var id = input ? String(input.value) : '';
    return variants.find(function (variant) {
      return String(variant.id) === id;
    }) || variants[0] || null;
  }

  function selectedQuantity(root) {
    var checked = root.querySelector('[data-dr-20260812-bundle-option]:checked');
    var raw = checked ? checked.value : 1;
    return Math.max(1, parseInt(raw, 10) || 1);
  }

  function setText(root, selector, value) {
    var node = root.querySelector(selector);
    if (node) node.textContent = value;
  }

  function updateCompare(node, compareAt, price, quantity, format) {
    if (!node) return;
    var shouldShow = Number(compareAt || 0) > Number(price || 0);
    node.hidden = !shouldShow;
    node.textContent = shouldShow ? money(Number(compareAt) * quantity, format) : '';
  }

  function announcePurchaseState(root, variant, quantity, totalText) {
    document.dispatchEvent(new CustomEvent('dr-20260812:purchasestate', {
      detail: {
        available: Boolean(variant && variant.available),
        quantity: quantity,
        totalText: totalText,
        variantId: variant ? variant.id : null,
        variantTitle: variant ? variant.title : ''
      }
    }));
  }

  function renderPurchase(root, variants) {
    var variant = selectedVariant(root, variants);
    if (!variant) return;

    var quantity = selectedQuantity(root);
    var format = root.getAttribute('data-money-format') || '${{amount}}';
    var total = Number(variant.price || 0) * quantity;
    var totalText = money(total, format);
    var submit = root.querySelector('[data-dr-20260812-submit]');
    var submitLabel = root.querySelector('[data-dr-20260812-submit-label]');

    findAll(root, '[data-dr-20260812-bundle-card]').forEach(function (card) {
      var radio = card.querySelector('[data-dr-20260812-bundle-option]');
      card.classList.toggle('is-selected', Boolean(radio && radio.checked));

      var cardQuantity = Math.max(1, parseInt(radio ? radio.value : 1, 10) || 1);
      setText(card, '[data-dr-20260812-bundle-price]', money(Number(variant.price || 0) * cardQuantity, format));
      updateCompare(
        card.querySelector('[data-dr-20260812-bundle-compare]'),
        variant.compare_at_price,
        variant.price,
        cardQuantity,
        format
      );
    });

    setText(root, '[data-dr-20260812-total-price]', totalText);
    setText(root, '[data-dr-20260812-submit-price]', totalText);
    updateCompare(
      root.querySelector('[data-dr-20260812-total-compare]'),
      variant.compare_at_price,
      variant.price,
      quantity,
      format
    );

    if (submit) {
      submit.disabled = !variant.available;
      submit.setAttribute('aria-disabled', variant.available ? 'false' : 'true');
    }
    if (submitLabel) {
      submitLabel.textContent = variant.available ? (submitLabel.getAttribute('data-default-label') || 'ADD TO CART') : 'Sold out';
    }

    announcePurchaseState(root, variant, quantity, totalText);
  }

  function cartComponent() {
    return document.querySelector('cart-drawer') || document.querySelector('cart-notification');
  }

  function addEndpoint() {
    var route = window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add';
    return /\.js(?:\?|$)/.test(route) ? route : route.replace(/\/?$/, '.js');
  }

  function errorMessage(payload, fallback) {
    if (!payload) return fallback;
    if (typeof payload.description === 'string') return payload.description;
    if (typeof payload.message === 'string') return payload.message;
    if (typeof payload.errors === 'string') return payload.errors;
    return fallback;
  }

  function submitProduct(root, event, variants) {
    event.preventDefault();
    var form = event.currentTarget;
    var submit = root.querySelector('[data-dr-20260812-submit]');
    var status = root.querySelector('[data-dr-20260812-form-status]');
    var variant = selectedVariant(root, variants);

    if (!variant || !variant.available || !submit || submit.classList.contains('is-loading')) return;

    submit.classList.add('is-loading');
    submit.setAttribute('aria-disabled', 'true');
    if (status) {
      status.classList.remove('is-error');
      status.textContent = 'Adding your selection…';
    }

    var data = new FormData(form);
    var cart = cartComponent();

    if (cart && typeof cart.getSectionsToRender === 'function') {
      var sectionIds = cart.getSectionsToRender().map(function (section) { return section.id; });
      data.set('sections', sectionIds.join(','));
      data.set('sections_url', window.location.pathname);
    }

    fetch(addEndpoint(), {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: data
    })
      .then(function (response) {
        return response.json().then(function (payload) {
          if (!response.ok || payload.status) throw new Error(errorMessage(payload, 'This item could not be added.'));
          return payload;
        });
      })
      .then(function (payload) {
        if (status) status.textContent = 'Added to cart.';

        if (cart && typeof cart.renderContents === 'function') {
          cart.renderContents(payload);
          if (typeof cart.open === 'function') cart.open();
        } else {
          window.location.assign(window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart');
        }

        if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
          window.publish(window.PUB_SUB_EVENTS.cartUpdate, {
            source: 'direct-response-product-20260812',
            productVariantId: variant.id,
            cartData: payload
          });
        }
      })
      .catch(function (error) {
        if (status) {
          status.classList.add('is-error');
          status.textContent = error.message || 'This item could not be added. Please try again.';
        }
      })
      .finally(function () {
        submit.classList.remove('is-loading');
        submit.setAttribute('aria-disabled', submit.disabled ? 'true' : 'false');
      });
  }

  function initPurchase(root) {
    if (root.dataset.drPurchaseInitialized === 'true') return;
    root.dataset.drPurchaseInitialized = 'true';

    var variants = parseVariants(root);
    var form = root.querySelector('[data-dr-20260812-20260812-product-form]');
    var variantInput = root.querySelector('[data-dr-20260812-variant-select]');
    var submitLabel = root.querySelector('[data-dr-20260812-submit-label]');
    var controller = new AbortController();
    root.drAbortController = controller;

    if (submitLabel) {
      submitLabel.setAttribute('data-default-label', submitLabel.getAttribute('data-add-label') || 'ADD TO CART');
    }

    if (variantInput) {
      variantInput.addEventListener('change', function () {
        renderPurchase(root, variants);
      }, { signal: controller.signal });
    }

    findAll(root, '[data-dr-20260812-bundle-option]').forEach(function (radio) {
      radio.addEventListener('change', function () {
        renderPurchase(root, variants);
      }, { signal: controller.signal });
    });

    if (form) {
      form.addEventListener('submit', function (event) {
        submitProduct(root, event, variants);
      }, { signal: controller.signal });
    }

    renderPurchase(root, variants);
  }

  function updateSticky(sticky, detail) {
    if (!sticky || !detail) return;
    var label = sticky.querySelector('[data-dr-20260812-sticky-label]');
    var price = sticky.querySelector('[data-dr-20260812-sticky-price]');
    var button = sticky.querySelector('[data-dr-20260812-scroll-purchase]');

    if (label) {
      label.textContent = detail.quantity > 1 ? detail.quantity + ' showers selected' : '1 shower selected';
    }
    if (price) price.textContent = detail.totalText || '';
    if (button) {
      button.disabled = !detail.available;
      button.setAttribute('aria-disabled', detail.available ? 'false' : 'true');
    }
  }

  function initSticky(sectionRoot) {
    var sticky = sectionRoot.querySelector('[data-dr-20260812-sticky]');
    var heroCta = sectionRoot.querySelector('[data-dr-20260812-hero-cta]');
    if (!sticky || !heroCta || sticky.dataset.drInitialized === 'true') return;
    sticky.dataset.drInitialized = 'true';

    var heroVisible = true;
    var purchaseVisible = false;
    var purchase = null;
    var observedPurchase = null;
    var observer = null;
    var controller = new AbortController();
    sticky.drAbortController = controller;

    function renderVisibility() {
      var shouldShow = Boolean(purchase) && !heroVisible && !purchaseVisible;
      sticky.hidden = !shouldShow;
      sticky.classList.toggle('is-visible', shouldShow);
    }

    function refreshPurchaseTarget() {
      purchase = document.querySelector(PURCHASE_SELECTOR);
      if (!observer || purchase === observedPurchase) return;
      if (observedPurchase) observer.unobserve(observedPurchase);
      observedPurchase = purchase;
      purchaseVisible = false;
      if (observedPurchase) observer.observe(observedPurchase);
      renderVisibility();
    }

    sticky.drRefreshTarget = refreshPurchaseTarget;

    document.addEventListener('dr-20260812:purchasestate', function (event) {
      refreshPurchaseTarget();
      updateSticky(sticky, event.detail);
    }, { signal: controller.signal });

    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.target === heroCta) heroVisible = entry.isIntersecting;
          if (entry.target === purchase) purchaseVisible = entry.isIntersecting;
        });
        renderVisibility();
      }, { threshold: 0.05 });
      observer.observe(heroCta);
      refreshPurchaseTarget();
      sticky.drObserver = observer;
    }
  }

  function scrollToPurchase() {
    var purchase = document.querySelector(PURCHASE_SELECTOR);
    if (!purchase) return;
    purchase.scrollIntoView({
      behavior: prefersReducedMotion.matches ? 'auto' : 'smooth',
      block: 'center'
    });
    window.setTimeout(function () {
      purchase.focus({ preventScroll: true });
    }, prefersReducedMotion.matches ? 0 : 450);
  }

  function initSection(sectionRoot) {
    if (!sectionRoot || sectionRoot.dataset.drInitialized === 'true') return;
    sectionRoot.dataset.drInitialized = 'true';
    findAll(sectionRoot, PURCHASE_SELECTOR).forEach(initPurchase);
    if (sectionRoot.getAttribute('data-dr-20260812-section') === 'hero') initSticky(sectionRoot);
  }

  function init(context) {
    findAll(context || document, ROOT_SELECTOR).forEach(initSection);
    findAll(document, '[data-dr-20260812-sticky]').forEach(function (sticky) {
      if (typeof sticky.drRefreshTarget === 'function') sticky.drRefreshTarget();
    });
  }

  function destroy(context) {
    findAll(context, ROOT_SELECTOR).forEach(function (sectionRoot) {
      findAll(sectionRoot, PURCHASE_SELECTOR).forEach(function (purchase) {
        if (purchase.drAbortController) purchase.drAbortController.abort();
      });
      findAll(sectionRoot, '[data-dr-20260812-sticky]').forEach(function (sticky) {
        if (sticky.drAbortController) sticky.drAbortController.abort();
        if (sticky.drObserver) sticky.drObserver.disconnect();
      });
    });
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-dr-20260812-scroll-purchase]');
    if (!trigger) return;
    event.preventDefault();
    scrollToPurchase();
  });

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    destroy(event.target);
    window.setTimeout(function () { init(document); }, 0);
  });

  document.addEventListener('shopify:section:reorder', function () {
    init(document);
  });

  window.DirectResponseProduct20260812 = {
    destroy: destroy,
    init: init,
    scrollToPurchase: scrollToPurchase,
    version: '1.0.0'
  };

  init(document);
})();
